import React, { useContext } from 'react'
import moment from "moment";
import Modal from './Modal'
import { UserContext, TourContext } from "../../context"
import { login } from "../../api/api"
import {
	FORM,
	AUTH_ERROR,
	AUTH_LOGIN,
	AUTH_ERROR_MESSAGE,
	AUTH_ERROR_MESSAGE_2,
	AUTH_NO_ACTIVE_SUBSCRIPTION,
	AUTH_NO_ACTIVE_SUBSCRIPTION_MESSAGE,
	AUTH_SESSION_IS_ACTIVE
} from "../../constant"
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'
import {ModalContext} from "../../context"

export default function ModalLogin({isOpen,closeModal}) {
	const [form, setForm] = React.useState({[FORM.LOGIN]: '', [FORM.PASSWORD]: ''})
	const [state, setState] = React.useState({error: '', focus: false})
	const { toggleModal, openModal, setModalParams } = useContext(ModalContext)
	const { setUserParams } = useContext(UserContext)
	const { tour } = useContext(TourContext)
	const { error, focus} = state

	const fetch = async () => {
		const data = await login({[FORM.LOGIN]: form[FORM.LOGIN], [FORM.PASSWORD]: form[FORM.PASSWORD]})
		setUserParams({...data,...(tour.tour ? {categories: []}: null)});
		if(data.auth === AUTH_NO_ACTIVE_SUBSCRIPTION) {
			setState(prevState => ({...prevState, error: AUTH_NO_ACTIVE_SUBSCRIPTION_MESSAGE}))
		}else if(data.auth === AUTH_ERROR) {
			if(moment().unix() > 1668643200){ // 17 ноября 2022
				setState(prevState => ({...prevState, error: AUTH_ERROR_MESSAGE}))
			} else {
				setState(prevState => ({...prevState, error: AUTH_ERROR_MESSAGE_2}))
			}
		} else if(data.auth === AUTH_SESSION_IS_ACTIVE){
			openModal('sessionActive');
			setModalParams(form);
		} else if(data.auth === AUTH_LOGIN){
			closeModal()
		}
	};

	const onChange = (e) => {
		e.stopPropagation()
		const { name, value } = e.target
		setForm(prevState => ({...prevState, [name]: value}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if(form[FORM.LOGIN] !== '' && form[FORM.PASSWORD] !== '') {
			fetch()
		}
	}


	const onFocus = (e) => {
		const { name } = e.target
		setState(prevState => ({...prevState, focus: name }))
	}

	const registration = () =>{
		toggleModal({login: false, registration: true})
	}

	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			style={{
				content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'480px',
					maxWidth: '100%',
					margin: '0 auto'
				}
			}}
		>
			<>
				<div className={css.title + ' ' + css.login}>Вход на сайт</div>
				<form onSubmit={onSubmit}>
					<label className={css.field + ' ' +(focus === FORM.LOGIN ? css.focus : '') + ' ' + (form[FORM.LOGIN] ? css.hasValue : '')}>
						<span className={css.label}>Имя пользователя</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.LOGIN]}
							name={FORM.LOGIN}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label className={css.field + ' ' +(focus === FORM.PASSWORD ? css.focus : '') + ' ' + (form[FORM.PASSWORD] ? css.hasValue : '')}>
						<span className={css.label}>Пароль</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.PASSWORD]}
							name={FORM.PASSWORD}
							type="password"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<div className={css.field}>
						{error
							? <div className={lCss.button + ' ' + lCss.w100 + ' ' + lCss.error} dangerouslySetInnerHTML={{__html: error}}/>
							: <button className={lCss.button + ' ' + lCss.w100 + ' ' +( (form[FORM.LOGIN] && form
								[FORM.PASSWORD]) ? '' : lCss.disabled )}>
								Войти
							</button>
						}
					</div>
					<div className={css.rule}>
						Нет логина и пароля? <span className={css.blue} onClick={registration}>Свяжитесь с нами</span>
					</div>
				</form>
			</>
		</Modal>
	)
}